export const attendanceProps = {
  basename: "/plataforma/atendimento",
};
